export class ModuleTestItem {
    TestId: number;
    ModuleId: number;
    TestAssignmentId: number;
    AssignmentStatus: number;
    Score: number;
    StartDate: Date;
    ElementSubTypeId: number; // 1 = Pre-Test, 2 = Post-Test

    constructor(init?: Partial<ModuleTestItem>) {
        Object.assign(this, init);
    }

    DisplayTitle(): string {
        if (this.ElementSubTypeId === 1) {
            return "Module Pre-Test";
        }
        else if (this.ElementSubTypeId === 2) {
            return "Module Post-Test";
        }
        else {
            return "Test";
        }
    }
}